import { render, staticRenderFns } from "./ExplainBlock.vue?vue&type=template&id=924f4a98&scoped=true"
import script from "./ExplainBlock.vue?vue&type=script&lang=js"
export * from "./ExplainBlock.vue?vue&type=script&lang=js"
import style0 from "./ExplainBlock.vue?vue&type=style&index=0&id=924f4a98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924f4a98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('924f4a98')) {
      api.createRecord('924f4a98', component.options)
    } else {
      api.reload('924f4a98', component.options)
    }
    module.hot.accept("./ExplainBlock.vue?vue&type=template&id=924f4a98&scoped=true", function () {
      api.rerender('924f4a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Incubator/ExplainBlock.vue"
export default component.exports